import PropTypes from 'prop-types';
import React, { Component } from 'react';
import Thumbnail from 'components/Thumbnails/Thumbnail';
import styles from './AudioThumbnails.module.scss';
import Shiitake from 'shiitake';

class AudioThumbnails extends Component {
  static propTypes = {
    projects: PropTypes.array,
  };

  render() {
    const { projects } = this.props;
    return (
      <div className={styles.audioThumbnailsContainer}>
        {projects
          .filter((project) => /audio|other/.test(project?.mediaType))
          .map((project, index) => {
            if (index <= 1) {
              return (
                <div
                  className={styles.audioContainer}
                  key={`audio-image-divcontainer-${project.id}`}
                >
                  <Thumbnail
                    className={styles.audioImage}
                    thumbnails={project.thumbnails}
                    style={{ width: '100%', height: '100%' }}
                    square
                  />
                  <div className={styles.descriptionContainer}>
                    <p className={styles.audioTitle}>{project.title}</p>
                    <Shiitake lines={3} className={styles.audioDescription}>
                      {project.description}
                    </Shiitake>
                  </div>
                </div>
              );
            }
          })}
      </div>
    );
  }
}

export default AudioThumbnails;
